import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { LoadingScreen } from 'modules/Common/components';
import authManager from '../authManager';

const LoginPage = ({ location }) => {
  const userManager = authManager.getUserManager();
  useEffect(() => {
    const data = {
      state: {
        redirectUrl: new URLSearchParams(location.search).returnTo,
      },
    };

    userManager.signinRedirect(data);
  });

  return <LoadingScreen message="Redirecting to login..." />;
};

LoginPage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default LoginPage;
